import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Header from './Header';

import {
  Wrapper,
  RecipeWrapper,
  RecipeTitle,
  LeftList,
  DeveloperInfo,
  ServicesList,
  CheckboxBtn,
  Checkbox,
  DeveloperSelectWrapper,
  RecipesList,
  RangeSelectWrapper,
  ProductNameWrapper,
  RatioNameWrapper,
  Footer,
  CancelBtn,
  SaveBtn,
  AddMoreBtn,
  CreateNewRecipeBtn,
  CloseIcon,
  SavedProductItem,
  SavedProductName,
  SavedProductRatio,
  DeleteBtn,
  SavedProductColor,
} from './HairColor.style';

import { TEXT_GRAY } from '../../../../styles/variables.style';

class HairColor extends Component {
  state = {
    recipes: this.props.recipes
      ? this.props.recipes.map(recipe => ({
          services: recipe.services,
          products: recipe.hairAgents.map(agent => ({
            type: agent.agentType,
            range: agent.range,
            product: agent.agentName,
            ratio: agent.ratio,
            saved: true,
            hex: agent.hex || '',
          })),
        }))
      : [
          {
            services: [],
            products: [
              {
                type: 'Developer',
                range: 'Others',
                ratio: '',
                product: '',
                saved: false,
                isDirty: false,
              },
            ],
          },
        ],
  };

  getCorrectProductContent = (i, product, productIdx) => {
    const { ranges, summary, copy } = this.props;
    const currentRange = ranges.colorRanges.find(range => range.name === product.range);
    let productContent = (
      <DeveloperSelectWrapper>
        <select onChange={this.handleTypeChange(i, productIdx)} value="Product Type">
          <option value="Product Type" disabled>
            {copy.product_type}
          </option>
          <option value="Developer">{copy.developer}</option>
          <option value="Color">{copy.color}</option>
        </select>
      </DeveloperSelectWrapper>
    );

    if (product.isDirty) {
      productContent = (
        <Fragment>
          <DeveloperSelectWrapper>
            <select onChange={this.handleTypeChange(i, productIdx)} value={product.type || 'Developer'}>
              <option value="Product Type" disabled>
                {copy.product_type}
              </option>
              <option value="Developer">{copy.developer}</option>
              <option value="Color">{copy.color}</option>
            </select>
          </DeveloperSelectWrapper>
          <RangeSelectWrapper>
            <select onChange={this.handleRangeChange(i, productIdx)} value={product.range || 'Others'}>
              {product.type === 'Developer' &&
                ranges.developerRanges.map(range => <option key={range.name}>{range.name}</option>)}
              {product.type === 'Color' &&
                ranges.colorRanges.map(range => <option key={range.name}>{range.name}</option>)}
              <option value="Others">{copy.others}</option>
            </select>
          </RangeSelectWrapper>
          <ProductNameWrapper>
            <input
              type="text"
              onChange={this.handleProductNameChange(i, productIdx)}
              placeholder={product.type === 'Developer' ? 'Enter Developer Info' : 'Enter Color Info'}
              value={product.product || ''}
            />
          </ProductNameWrapper>
          <RatioNameWrapper>
            <input type="text" onChange={this.handleRatioChange(i, productIdx)} placeholder={copy.ratio} />
          </RatioNameWrapper>
        </Fragment>
      );
    }

    if (product.saved) {
      if (product.type === 'Developer') {
        productContent = (
          <SavedProductItem>
            <SavedProductName>{product.product}</SavedProductName>
            {product.ratio && (
              <SavedProductRatio>
                {copy.ratio}: {product.ratio}
              </SavedProductRatio>
            )}
            {!summary && (
              <DeleteBtn onClick={this.handleCancel(i, productIdx)}>
                <CloseIcon />
              </DeleteBtn>
            )}
          </SavedProductItem>
        );
      } else if (product.type === 'Color') {
        let colorCode = TEXT_GRAY.COMMON_5;
        if (currentRange) {
          /* eslint-disable */
          currentRange.colorGroups.forEach(colorGroup => {
            return colorGroup.colors.forEach(color => {
              if (color.name === product.product) {
                colorCode = color.colorCode;
              }
            });
          });
          /* eslint-enable */
        }
        productContent = (
          <SavedProductItem>
            <SavedProductColor color={product.hex || colorCode} />
            <SavedProductName style={{ maxWidth: '212px' }}>
              {product.range} {product.product}
            </SavedProductName>
            {product.ratio && (
              <SavedProductRatio>
                {copy.ratio}: {product.ratio}
              </SavedProductRatio>
            )}
            {!summary && (
              <DeleteBtn onClick={this.handleCancel(i, productIdx)}>
                <CloseIcon />
              </DeleteBtn>
            )}
          </SavedProductItem>
        );
      }
    }

    return productContent;
  };

  handleTypeChange = (i, productIdx) => e => {
    const { recipes } = this.state;
    const newRecipe = recipes[i];
    this.setState({
      recipes: [
        ...recipes.slice(0, i),
        {
          ...newRecipe,
          products:
            newRecipe.products.length > 0
              ? [
                  ...newRecipe.products.slice(0, productIdx),
                  {
                    ...newRecipe.products[productIdx],
                    type: e.target.value,
                    isDirty: true,
                  },
                  ...newRecipe.products.slice(productIdx + 1),
                ]
              : [
                  {
                    type: e.target.value,
                    range: newRecipe.products[productIdx] ? newRecipe.products[productIdx].range : 'Others',
                    ratio: newRecipe.products[productIdx] ? newRecipe.products[productIdx].ratio : '',
                    product: newRecipe.products[productIdx] ? newRecipe.products[productIdx].product : '',
                    saved: newRecipe.products[productIdx] ? newRecipe.products[productIdx].saved : false,
                    isDirty: newRecipe.products[productIdx] ? newRecipe.products[productIdx].isDirty : false,
                  },
                ],
        },
        ...recipes.slice(i + 1),
      ],
    });
  };

  updateProductFromRange = (i, productIdx, key, value, cb) => {
    const { recipes } = this.state;
    const newRecipe = recipes[i];
    this.setState(
      {
        recipes: [
          ...recipes.slice(0, i),
          {
            ...newRecipe,
            products: [
              ...newRecipe.products.slice(0, productIdx),
              {
                ...newRecipe.products[productIdx],
                [key]: value,
              },
              ...newRecipe.products.slice(productIdx + 1),
            ],
          },
          ...recipes.slice(i + 1),
        ],
      },
      () => {
        const { recipes: newRecipes } = this.state;
        if (cb) cb(newRecipes);
      }
    );
  };

  handleRangeChange = (i, productIdx) => e => {
    this.updateProductFromRange(i, productIdx, 'range', e.target.value);
  };

  handleProductNameChange = (i, productIdx) => e => {
    this.updateProductFromRange(i, productIdx, 'product', e.target.value);
  };

  handleRatioChange = (i, productIdx) => e => {
    this.updateProductFromRange(i, productIdx, 'ratio', e.target.value || '');
  };

  handleCancel = (i, productIdx) => () => {
    const { recipes } = this.state;
    const { onUpdateTreatment } = this.props;
    const newRecipe = recipes[i];
    const newProducts = [...newRecipe.products.slice(0, productIdx), ...newRecipe.products.slice(productIdx + 1)];

    let newState = {
      recipes: [
        ...recipes.slice(0, i),
        {
          ...newRecipe,
          products:
            newProducts.length > 0
              ? newProducts
              : [
                  {
                    type: 'Developer',
                    range: 'Others',
                    ratio: '',
                    product: '',
                    saved: false,
                    isDirty: false,
                  },
                ],
        },
        ...recipes.slice(i + 1),
      ],
    };

    if (recipes.length > 1 && newProducts.length === 0) {
      newState = {
        recipes: [...recipes.slice(0, i), ...recipes.slice(i + 1)],
      };
    }

    this.setState(newState, () => {
      onUpdateTreatment(newState.recipes.filter(recipe => recipe.products.every(product => product.saved)));
    });
  };

  handleSave = (i, productIdx) => () => {
    const { onUpdateTreatment } = this.props;
    this.updateProductFromRange(i, productIdx, 'saved', true, newRecipes => {
      onUpdateTreatment(newRecipes);
    });
  };

  handleCheckbox = (i, value) => () => {
    const { recipes } = this.state;
    const { onUpdateTreatment } = this.props;
    const existingService = recipes[i].services.indexOf(value);
    this.setState(
      {
        recipes: [
          ...recipes.slice(0, i),
          {
            ...recipes[i],
            services:
              existingService < 0
                ? [...new Set(recipes[i].services.concat(value))]
                : [...recipes[i].services.slice(0, existingService), ...recipes[i].services.slice(existingService + 1)],
          },
          ...recipes.slice(i + 1),
        ],
      },
      () => {
        const { recipes: newRecipes } = this.state;
        if (!recipes[i].products.find(product => !product.saved)) {
          onUpdateTreatment(newRecipes);
        }
      }
    );
  };

  handleAddMore = i => () => {
    const { recipes } = this.state;
    this.setState({
      recipes: [
        ...recipes.slice(0, i),
        {
          ...recipes[i],
          products: recipes[i].products.concat({
            type: 'Developer',
            range: 'Others',
            ratio: '',
            product: '',
            saved: false,
            isDirty: false,
          }),
        },
        ...recipes.slice(i + 1),
      ],
    });
  };

  handleCreateNewRecipe = () => {
    this.setState(({ recipes }) => ({
      recipes: recipes.concat({
        services: [],
        products: [
          {
            type: 'Developer',
            range: 'Others',
            ratio: '',
            product: '',
            saved: false,
            isDirty: false,
          },
        ],
      }),
    }));
  };

  isValidProduct = product => {
    const { ranges } = this.props;
    if (product.range === 'Others') {
      return true;
    }
    if (product.type === 'Developer') {
      const currentRange = ranges.developerRanges.find(range => range.name === product.range);
      if (!currentRange || !currentRange.productLists) return false;
      const developerList = currentRange.productLists.filter(productList => productList.productType === 'Developer');

      return developerList.find(productList =>
        productList.products.find(p => {
          if (p.name && p.name.split(' ') && product.product) {
            return p.name.split(' ').pop() === product.product;
          }
          return false;
        })
      );
    }
    if (product.type === 'Color') {
      const currentRange = ranges.colorRanges.find(range => range.name === product.range);
      if (!currentRange || !currentRange.colorGroups) return false;
      return currentRange.colorGroups.find(colorGroup =>
        colorGroup.colors.find(color => color.name === product.product)
      );
    }
    return false;
  };

  render() {
    const { onRemove, treatment, summary, copy } = this.props;
    const { recipes } = this.state;
    return (
      <Wrapper>
        <Header name={copy.hair_color} onRemove={onRemove} summary={summary} />
        <RecipesList>
          {recipes.map(({ services, products }, i) => (
            <RecipeWrapper key={`${treatment.type}-${i}` /* eslint-disable-line */}>
              <LeftList>
                <RecipeTitle>
                  /{copy.recipe} {i + 1 < 10 ? `0${i + 1}` : i + 1}
                </RecipeTitle>
                <ServicesList>
                  <li>
                    <CheckboxBtn onClick={this.handleCheckbox(i, 'New Growth')} disabled={summary}>
                      <Checkbox checked={services.indexOf('New Growth') >= 0} />
                      {copy.new_growth}
                    </CheckboxBtn>
                  </li>
                  <li>
                    <CheckboxBtn onClick={this.handleCheckbox(i, 'Colored Hair')} disabled={summary}>
                      <Checkbox checked={services.indexOf('Colored Hair') >= 0} />
                      {copy.colored_hair}
                    </CheckboxBtn>
                  </li>
                  <li>
                    <CheckboxBtn onClick={this.handleCheckbox(i, 'Foil Work')} disabled={summary}>
                      <Checkbox checked={services.indexOf('Foil Work') >= 0} />
                      {copy.foil_work}
                    </CheckboxBtn>
                  </li>
                </ServicesList>
              </LeftList>
              <DeveloperInfo>
                {products.map((product, productIdx) => {
                  const currentProduct = recipes[i].products[productIdx];
                  const disabled = currentProduct.product.trim().length === 0 || !this.isValidProduct(currentProduct);
                  return (
                    <Fragment key={productIdx /* eslint-disable-line */}>
                      {this.getCorrectProductContent(i, product, productIdx)}
                      {product.isDirty &&
                        !summary && (
                          <Footer>
                            {product.saved ? (
                              productIdx === products.length - 1 && (
                                <AddMoreBtn onClick={this.handleAddMore(i)}>{copy.add_more}</AddMoreBtn>
                              )
                            ) : (
                              <Fragment>
                                <CancelBtn onClick={this.handleCancel(i, productIdx)}>{copy.cancel}</CancelBtn>
                                <SaveBtn onClick={this.handleSave(i, productIdx)} disabled={disabled}>
                                  {copy.save_agent}
                                </SaveBtn>
                              </Fragment>
                            )}
                          </Footer>
                        )}
                    </Fragment>
                  );
                })}
              </DeveloperInfo>
            </RecipeWrapper>
          ))}
        </RecipesList>
        {!!recipes.find(recipe => recipe.products.find(product => !product.saved)) ||
          (!summary && (
            <CreateNewRecipeBtn onClick={this.handleCreateNewRecipe}>{copy.create_new_recipe}</CreateNewRecipeBtn>
          ))}
      </Wrapper>
    );
  }
}

HairColor.defaultProps = {
  ranges: {
    developerRanges: [''],
    colorRanges: [''],
  },
  summary: false,
  recipes: null,
  onRemove: () => {},
  onUpdateTreatment: () => {},
};

HairColor.propTypes = {
  onRemove: PropTypes.func,
  treatment: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
  onUpdateTreatment: PropTypes.func,
  ranges: PropTypes.shape({}),
  summary: PropTypes.bool,
  recipes: PropTypes.arrayOf(PropTypes.shape()),
  copy: PropTypes.shape({}).isRequired,
};

export default HairColor;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/Treatments/HairColor.js